import React, { useState } from "react";
import { Form, Input, Button, Checkbox, TextArea } from "semantic-ui-react";
import { producaov2 as api } from "../../../../services/apis";
import swal from "sweetalert";
import AlunosSelector from "../../AlunosSelector";
import CourseAlunoSelector from "../../CourseAlunoSelector";
import ReactLoading from "react-loading";

const formatDateForInput = (date) => {
  if (!date || isNaN(date)) return "";
  const pad = (num) => String(num).padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());

  return `${year}-${month}-${day}`;
};

const Formulario = (props) => {
  const [alunoSelected, setAlunoSelected] = useState("");
  const [cursoAluno, setCursoAluno] = useState([]);
  const [selectedCourseID, setSelectedCourseID] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isVitalicio, setIsVitalicio] = useState(false);
  const [obs, setObs] = useState("");
  const [novaValidade, setNovaValidade] = useState("");

  function submitValidate() {
    if (!isVitalicio && !novaValidade) {
      swal({
        title: "Atenção!",
        text:
          "Por favor, selecione uma data de validade ou marque a opção 'Vitalicio'.",
        icon: "warning",
        button: "Ok",
      });
      return;
    }
    if (!obs || obs.trim() === "") {
      swal({
        title: "Atenção!",
        text: "O campo de motivo é obrigatório.",
        icon: "warning",
        button: "Ok",
      });
      return;
    }
    const data = {
      id_aluno: alunoSelected,
      validade: isVitalicio ? 180 : novaValidade,
      courseSelected: selectedCourseID,
      obs,
    };

    api
      .post(`admin/change-validity-course`, data, {
        headers: {
          access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
        },
      })
      .then(async (res) => {
        swal(
          "Validade alterada",
          "A Validade do Aluno foi devidamente alterada",
          "success"
        );
      })
      .catch((err) => {
        const errorMessage = err?.response?.data?.message;

        if (errorMessage) {
          swal({
            title: "Erro na Validação",
            text: errorMessage,
            icon: "error",
            button: "Ok",
          });
        } else {
          swal({
            title: "Requisição mal sucedida",
            text: "Ocorreu um erro inesperado. Tente novamente.",
            icon: "error",
            button: "Ok",
          });
        }
      });
  }

  const handleAlunoChange = (value) => {
    setLoading(false);
    setAlunoSelected(value);
    api
      .get(`admin/eadalunos/${value}?origem=validade`, {
        headers: {
          access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
        },
      })
      .then((res) => {
        const { aluno } = res.data;
        if (aluno) {
          setCursoAluno(aluno?.pessoa_cursos);
          setLoading(true);
        }
      })
      .catch((err) => {
        setLoading(true);
      });
  };

  const onChangeSelectedCourseID = (courseID) => {
    setSelectedCourseID(courseID);
    const cursoSelecionado = cursoAluno.find(
      (curso) => curso.curso.id === courseID
    );

    if (cursoSelecionado) {
      const diasDeValidade = Number(cursoSelecionado.validade);

      if (diasDeValidade === 180) {
        setIsVitalicio(true);
        setNovaValidade("");
      } else {
        setIsVitalicio(false);
        const dataInsert = new Date(cursoSelecionado.data_insert);
        dataInsert.setDate(dataInsert.getDate() + diasDeValidade);
        const dataFormatada = formatDateForInput(dataInsert);
        setNovaValidade(dataFormatada);
      }
    } else {
      setNovaValidade("");
      setIsVitalicio(false);
    }
  };

  const handleVitalicioChange = (e, { checked }) => {
    setIsVitalicio(checked);
    if (checked) {
      setNovaValidade("");
    }
  };

  return (
    <Form>
      <Form.Group widths="equal">
        <AlunosSelector handleChange={handleAlunoChange} />
      </Form.Group>
      {cursoAluno.length > 0 && loading && (
        <Form.Group widths="equal">
          <CourseAlunoSelector
            courses={cursoAluno}
            onChangeCourseID={onChangeSelectedCourseID}
            selectedCourseID={selectedCourseID}
          />
        </Form.Group>
      )}
      {!loading && <ReactLoading color={"orange"} type={"spin"} width={24} />}

      {selectedCourseID && (
        <>
          <Form.Group widths="equal">
            <Form.Field
              control={Input}
              label="Nova Data de Validade"
              type="date"
              value={novaValidade}
              onChange={(e) => setNovaValidade(e.target.value)}
              disabled={isVitalicio}
            />
          </Form.Group>
          <Form.Group widths="equal">
            <TextArea
              placeholder="Descreva o motivo desta troca de validade"
              onChange={(e) => setObs(e.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Checkbox
              label="Vitalicio"
              checked={isVitalicio}
              onChange={handleVitalicioChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Field control={Button} onClick={() => submitValidate()}>
              Alterar Validade
            </Form.Field>
          </Form.Group>
        </>
      )}
    </Form>
  );
};

export default Formulario;
